import React from 'react'
import propTypes from 'prop-types'
import themeVars from 'theme/themeVars'
import CircularProgress from 'components/circularProgress'

const DEFAULT_SIZE = 1

const getStyles = (props) => {
  const {
    size = DEFAULT_SIZE,
    inline = false,
    transparent = false,
    dark = false,
    style,
  } = props

  let container
  if (!inline) {
    container = {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 100,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }
  }

  return {
    container: {
      ...container,
      backgroundColor: transparent ? 'transparent' : dark ? themeVars.palette.contrastBackgroundColor : themeVars.palette.whiteColor,
      ...style,
    },
    label: {
      ...themeVars.type.title,
      marginTop: 10 + ((size - 1) * 5),
      fontSize: 10 + (size * 5),
    },
  }
}

const Loading = (props) => {
  const styles = getStyles(props)
  const {size = DEFAULT_SIZE, color} = props
  let {label} = props

  if (label) {
    label = <span style={styles.label}>{label}</span>
  }

  return (
    <div style={styles.container} className="loading">
      <CircularProgress size={size} color={color}/>
      {label}
    </div>
  )
}

Loading.propTypes = {
  color: propTypes.string,
  dark: propTypes.bool,
  inline: propTypes.bool,
  label: propTypes.string,
  size: propTypes.number,
  style: propTypes.object,
  transparent: propTypes.bool,
}

export default Loading
